/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, styled, useMediaQuery, useTheme } from "@mui/material";
import ScormContent from "../pages/Course/pages/ChapterPage/ui/partials/ScormContent";

import AbsoluteContentCard from "../pages/Course/ui/partials/AbsoluteContentCard";
import { useEffect, useState } from "react";
import EvaluationContent from "../pages/Course/pages/ChapterPage/ui/partials/EvaluationContent";
import Loading from "./Loading";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { useParams } from "react-router-dom";
import { acessarCapitulo } from "../pages/ChapterPage/common/redux/chapterReducer";
import LinkChapter from "../../features/chapters/components/LinkChapter";
import { cn } from "../../shared/utils/cn";
import { useChapterQuadrants } from "../../features/quadrants/api/getChapterQuadrants";

const StyledContainer = styled("div")(({ theme }) => ({
  // height: "max-content",
  // overflowY: "auto",
  minHeight: "inherit",
  maxWidth: "100%",
  width: "100%",
  margin: 0,
  "@media screen and (min-width: 1200px)": {
    maxWidth: "unset",
  },
  "& > *": {
    "@media screen and (min-width: 800px)": {
      maxWidth: "calc(100vw - 248px)", // 120 + 2*24 + 100
    },
  },
}));

const Quadrants = ({ chapterId, enrollmentId }) => {
  const theme = useTheme();
  const isDisplaySmall = useMediaQuery(theme.breakpoints.down("md"));
  const [containerH, setContainerH] = useState(0);
  const chapterQuadrantsQuery = useChapterQuadrants({
    chapterId,
    config: {
      onSuccess: (data) => {
        const unsortedArr = data.map((module) => {
          const { column, row, isRow, isDouble, contentType } = module;

          const x =
            defaultContentGap / 2 +
            (isDisplaySmall
              ? 0
              : column * (defaultContentGap / 2 + defaultContentWidth));
          const y =
            defaultContentGap / 2 +
            (isDisplaySmall ? column + row : row) *
              (defaultContentGap / 2 + defaultContentHeight + BOX_BORDER_Y);
          const width =
            defaultContentWidth +
            (!isDisplaySmall && isRow
              ? defaultContentGap / 2 + defaultContentWidth
              : 0);
          const height =
            defaultContentHeight +
            (isDouble &&
            (!isDisplaySmall || ["DOCUMENTO", "TEXTO"].includes(contentType))
              ? defaultContentGap / 2 + defaultContentHeight + BOX_BORDER_Y
              : 0);

          return {
            ...module,
            width,
            height,
            x,
            y,
            row,
            column,
          };
        });

        const highestQuadrant = unsortedArr.sort((a, b) => {
          return a.y + a.height - (b.y + b.height);
        })[unsortedArr.length - 1];

        setContainerH(
          highestQuadrant.y + highestQuadrant.height + defaultContentGap
        );
      },
    },
  });
  const [wrapperWidth, setWrapperWidth] = useState(0);

  const [dropAreaRef, setDropAreaRef] = useState(null);
  const updateSize = () => {
    const rectDropArea = dropAreaRef?.getBoundingClientRect();

    setWrapperWidth(rectDropArea?.width ?? 0);
  };

  useEffect(() => {
    if (!dropAreaRef) return;

    const resizeObserver = new ResizeObserver(updateSize);

    resizeObserver.observe(dropAreaRef);

    return () => resizeObserver.disconnect();
  }, [dropAreaRef]);

  const BOX_BORDER_Y = 0;
  const defaultContentGap = !isDisplaySmall ? 20 : 5;

  const usefulArea = wrapperWidth - 3 * defaultContentGap;

  const MIN_CONTENT_WIDTH = 200;
  const MIN_CONTENT_HEIGHT = 200;

  const calculatedContentWidth = isDisplaySmall ? usefulArea : usefulArea / 2;
  const defaultContentWidth = Math.max(
    calculatedContentWidth,
    MIN_CONTENT_WIDTH
  );

  const calculatedContentHeight = 0.7 * defaultContentWidth;
  const defaultContentHeight = Math.max(
    calculatedContentHeight,
    MIN_CONTENT_HEIGHT
  );

  return (
    <Box
      sx={{
        height: isDisplaySmall ? "fit-content" : `${containerH}px`,
        width: "100%",
      }}
      position="relative"
      display="inline-block"
      ref={(ref) => {
        setDropAreaRef(ref);
      }}
    >
      {chapterQuadrantsQuery.isFetched ? (
        <>
          {chapterQuadrantsQuery.data?.map((module, index, list) => {
            const { column, row, isRow, isDouble, contentType } = module;
            const x =
              defaultContentGap / 2 +
              (isDisplaySmall
                ? 0
                : column * (defaultContentGap / 2 + defaultContentWidth));
            const y =
              defaultContentGap / 2 +
              (isDisplaySmall ? column + row : row) *
                (defaultContentGap / 2 + defaultContentHeight + BOX_BORDER_Y);
            const width =
              defaultContentWidth +
              (!isDisplaySmall && isRow
                ? defaultContentGap / 2 + defaultContentWidth
                : 0);
            const height =
              defaultContentHeight +
              (isDouble &&
              (!isDisplaySmall || ["DOCUMENTO", "TEXTO"].includes(contentType))
                ? defaultContentGap / 2 + defaultContentHeight + BOX_BORDER_Y
                : 0);

            return (
              <AbsoluteContentCard
                key={`content-${module.id}`}
                id={module.id}
                type={module.type}
                data={module}
                chapterId={chapterId}
                enrollmentId={enrollmentId}
                position={{ left: x, top: y }}
                size={{ width, height }}
                placement={{ row, column, isRow, isDouble }}
                fullWidth={isDisplaySmall}
              />
            );
          })}
        </>
      ) : (
        <Loading />
      )}{" "}
    </Box>
  );
};

function RenderContents({
  currentChapter,
  course = null,
  auth,
  className = "",
  ...props
}) {
  const { disciplinaid } = useParams();

  useEffect(() => {
    const mountPage = async () => {};
    mountPage();
  }, [currentChapter]);

  const chapter = course
    ? course.chapters.find(
        (chapter) => chapter.capituloid === Number(currentChapter)
      )
    : null;

  const theme = useTheme();
  const renderScorm = () => (
    <ScormContent
      chapter={chapter}
      capituloid={chapter.capituloid}
      matriculaid={course?.enrollment?.MATRICULAID}
    />
  );

  const renderEvaluation = () => (
    <Paper
      sx={{
        padding: "12px",
        overflow: "visible",
        [theme.breakpoints.down("sm")]: {
          padding: "0.25rem",
        },
      }}
    >
      <EvaluationContent
        courseId={disciplinaid}
        isEnquete={chapter?.tipo === "ENQUETE"}
        evaluationId={chapter.avaliacaoid || 35}
      />
    </Paper>
  );

  const render = (chapterType) => {
    switch (chapterType) {
      case "CONTEUDO":
        return (
          <Quadrants
            chapterId={chapter?.capituloid || currentChapter}
            enrollmentId={course?.enrollment?.MATRICULAID}
          />
        );
      case "SCORM":
        return renderScorm();
      case "ENQUETE":
        return renderEvaluation();
      case "AVALIACAO":
        return renderEvaluation();
      case "LINK":
        return (
          <LinkChapter
            url={chapter?.link_video_web}
            enrollmentId={course?.enrollment?.MATRICULAID}
            chapterId={currentChapter}
            courseId={disciplinaid}
          />
        );
      default:
        return (
          <Quadrants
            chapterId={chapter?.capituloid || currentChapter}
            enrollmentId={course?.enrollment?.MATRICULAID}
          />
        );
    }
  };

  return (
    <StyledContainer
      id="ChapterContentWrapper"
      className={cn("ChapterContentWrapper", className)}
      disableGutters
    >
      {render(chapter?.tipo)}
    </StyledContainer>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ acessarCapitulo }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RenderContents);
